import Channel from '@shared/classes/channel';
import Content from './pilotContent';
import { playerSelector } from '@shared/store/slices/player.slice';
import { useAppSelector } from '@shared/store/hooks';

export default function PilotFooterZapper({ asset }: { asset: Channel }) {
  const { pilot } = useAppSelector(playerSelector);
  const { currentEvent } = asset || {};
  return pilot ? (
    <Content
      currentChannel={asset}
      currentEvent={currentEvent}
      type={'channel'}
    />
  ) : null;
}
